import { Button, useDisclosure } from '@ds';
import { CaseAttachmentsModal } from '@features/modals/CaseAttachmentsModal';
import { TMDXFile } from '@/api/apis/files';
import { CaseLinkType } from '@/api/apis/case';

interface CaseAttachmentsButtonProps {
  files: TMDXFile[];
  links: CaseLinkType[];
  caseId: string;
  disabled?: boolean;
  showUploadBtn?: boolean;
  showDownloadBtn?: boolean;
  showDeleteBtn?: boolean;
  showEditBtn?: boolean;
  restrictRedactedFileDelete?: boolean;
  showRedactedMark?: boolean;
  hintLabel?: string;
  hintText?: string;
  requireRedactionConfirmation?: boolean;
  showRedactionInstructions?: boolean;
}

export const CaseAttachmentsButton = ({
  files,
  links,
  caseId,
  disabled,
  showUploadBtn,
  showDownloadBtn,
  showDeleteBtn,
  showEditBtn,
  restrictRedactedFileDelete,
  showRedactedMark,
  hintLabel,
  hintText,
  requireRedactionConfirmation,
  showRedactionInstructions,
}: CaseAttachmentsButtonProps) => {
  const { isOpen, onOpenChange } = useDisclosure();
  const attachmentsLength = files.length + links.length;
  return (
    <div className="flex gap-2 items-center">
      <Button
        disableRipple
        onClick={onOpenChange}
        variant="light"
        className="h-auto text-m-m! px-0 underline data-[hover=true]:bg-transparent"
      >
        {attachmentsLength} Attachments
      </Button>
      {isOpen && (
        <CaseAttachmentsModal
          caseId={caseId}
          onOpenChange={onOpenChange}
          files={files}
          links={links}
          disabled={disabled}
          showUploadBtn={showUploadBtn}
          showDownloadBtn={showDownloadBtn}
          showDeleteBtn={showDeleteBtn}
          showEditBtn={showEditBtn}
          restrictRedactedFileDelete={restrictRedactedFileDelete}
          showRedactedMark={showRedactedMark}
          hintLabel={hintLabel}
          hintText={hintText}
          requireRedactionConfirmation={requireRedactionConfirmation}
          showRedactionInstructions={showRedactionInstructions}
        />
      )}
    </div>
  );
};
